import { Link } from "react-router-dom";
import { bText } from "../tokens";

interface BAccountBannerProps {
  /** Primary line: the signed-in user's name (fall back to a workspace label). */
  name: string;
  /** Secondary line: usually the user's email. */
  subtitle?: string;
  /** When set, the whole banner becomes a Link to this route. */
  to?: string;
}

function initials(name: string): string {
  return (
    name
      .split(/[\s@.]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((s) => s[0]!.toUpperCase())
      .join("") || "?"
  );
}

// The signed-in account chip at the foot of the navy sidebar.
export default function BAccountBanner({ name, subtitle, to }: BAccountBannerProps) {
  const children = (
    <>
      <span
        style={{
          width: 32,
          height: 32,
          borderRadius: 99,
          background: "rgba(255,255,255,.1)",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          fontSize: bText.xs,
          flex: "0 0 auto",
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,.12)",
        }}
      >
        {initials(name)}
      </span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: bText.sm,
            color: "#fff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </div>
        {subtitle && (
          <div
            style={{
              fontSize: bText.xs,
              color: "#94a3b8",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
    </>
  );

  const style = {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px",
    borderRadius: 8,
    textDecoration: "none",
  } as const;

  if (to) {
    return (
      <Link to={to} style={style} className="sidebar-account">
        {children}
      </Link>
    );
  }
  return <div style={style}>{children}</div>;
}
